import { render, staticRenderFns } from "./selectItems.vue?vue&type=template&id=35148798&scoped=true&"
import script from "./selectItems.vue?vue&type=script&lang=js&"
export * from "./selectItems.vue?vue&type=script&lang=js&"
import style0 from "./selectItems.vue?vue&type=style&index=0&id=35148798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35148798",
  null
  
)

export default component.exports